<form #paymentSingleForm="ngForm" id="paymentSingleForm" validate>
  <h5> <b> <i translate> Payment Documents </i> </b> </h5>
  <hr class="mb-4 mr-3">
  <div class="mr-3 mt-2">
    <!-- Payment Documents -->
    @if (showText){
      <div class="col-12 mt-5">
        <p-floatlabel>
              <textarea pTextarea
                        #paymentDocuments="ngModel"
                        name="paymentDocuments"
                        rows="4"
                        [(ngModel)]="payment.memoContent"
                        [disabled]="paymentSavedOk || fileInput"
                        [pattern]="patternMemoContent"
                        required>
              </textarea>
          <label translate> Content </label>
        </p-floatlabel>

        <small *ngIf="paymentDocuments.errors?.pattern" class="text-danger" translate> MemoPayments.Incorrect Memo Content Format </small>
        <small *ngIf="paymentDocuments.touched && paymentDocuments.errors?.required" class="text-danger" translate> MemoPayments.Required Payment Documents </small>
      </div>
    }

    <!-- Selección de fichero -->
    @if (showFile){
      <div class="col-12 mt-1 mb-3 ml-2">
        <!-- Botón de subida -->
        <div class="d-flex">
          <p-fileupload #fileUpload
                        mode="basic"
                        chooseLabel="{{ 'MemoPayments.Select' | translate }}"
                        cancelLabel="{{ 'Common.Cancel' | translate }}"
                        chooseIcon="pi pi-upload"
                        cancelIcon="pi pi-times"
                        accept=".csv,.txt"
                        fileLimit="1"
                        [showCancelButton]="true"
                        [disabled]="fileInput || !!payment.memoContent"
                        (onSelect)="onFileChange($event)" />
          @if(fileInput){
            <p-chip [removable]="true" (onRemove)="removeFile()"> <span translate> {{ fileInput.name }} </span></p-chip>
          }
        </div>
      </div>
    }
  </div>
</form>
